import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import moment from 'moment';
import { ProjectWithActivities } from '../../models/project.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectsActivitiesService {
  private baseUrl = 'api/projectsactivities';

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  /**
   * Get projects and activities for a period
   * @param from Start date in YYYY-MM-DD format
   * @param to End date in YYYY-MM-DD format
   * @returns Observable array of projects and activities
   */
  get(from: moment.Moment, to: moment.Moment, includeBudget = false): Observable<ProjectWithActivities[]> {
    let url = `${this.baseUrl}/${from.format('YYYY-MM-DD')}/${to.format('YYYY-MM-DD')}`;
    if (includeBudget) {
      url += '?includeBudget=true';
    }
    return this.http.get<ProjectWithActivities[]>(url);
  }

  getRecent(): Observable<ProjectWithActivities[]> {
    return this.http.get<ProjectWithActivities[]>('/api/recentactivities');
  }
}
